import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProvaAcquisto} from "../_Models/prova-acquisto";
import {Permission} from "../../Login/_guards/Permission";
import {ApiRestService} from "../_services/api-rest.service";
import {ApiRestService as AdminApiRestService} from "../../Admin/_service/api-rest.service";
import {EditProvaAcquistoComponent} from "../edit-prova-acquisto/edit-prova-acquisto.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Rma} from "../_Models/rma";
import {RmaProdottoAddComponent} from "../rma-add/rma-prodotto-add.component";
import {RmaStoreService} from "../_services/rma-store.service";
import {Azienda} from "../../Admin/models/Azienda";
import {ToastrService} from "ngx-toastr";
import {environment} from "../../../environments/environment";
import {ApiPathsService} from "../../api-paths.service";
import {HttpClient, HttpEventType, HttpHeaders} from "@angular/common/http";
import {ApiRestService as sharedApiRestService} from "../../shared/_services/api-rest.service";
import {Progetto} from "../../Progetti/Models/Progetto";
import {Router} from "@angular/router";
import {CampoAggiuntivo, CampoUtility} from "../../shared/models/campo-aggiuntivo";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {RmaData} from "../RmaData";
import {NewsComponent} from "../../task/news/news.component";

@Component({
  selector: 'app-lista-prova-acquisto',
  templateUrl: './lista-prova-acquisto.component.html',
  styleUrls: ['./lista-prova-acquisto.component.css']
})
export class ListaProvaAcquistoComponent implements OnInit {
  @Input() List: ProvaAcquisto[] = [];
  @Output() ListChange = new EventEmitter<ProvaAcquisto[]>();
  @Input() Sede: number;
  @Output() SedeChange = new EventEmitter<number>();
  collectionSize: number = 0;
  @Input() Cliente : Azienda;
  @Input() Progetto : Progetto;
  @Input() Local: boolean = false;
  @Input() Headers: CampoAggiuntivo[];
  @Output() onRefresh = new EventEmitter();
  @Input() isModifyDisabled: boolean = false;
  Filter = {matricola: "", prodotto: ""};
  @Input() HasHeader: boolean = true;
  @Input() HasFilter: boolean = true;
  environment = environment;
  DropdownSources: any ={ProdottiSource:[]};
  constructor(
    private RmaStore: RmaStoreService,
    public permission: Permission,
    private apiRestService: ApiRestService,
    private authSvc: AuthenticationService,
    private adminApiRestService: AdminApiRestService,
    private modalService: NgbModal,
    private toastService: ToastrService,
    private apiPaths: ApiPathsService,
    private sharedApiRest: sharedApiRestService,
    private http: HttpClient,
    private rmaData: RmaData,
    private router: Router,
    private campoUtility: CampoUtility
  ) { }

  ngOnInit(): void {
    this.refresh(true)
  }
  refresh(init?: boolean){
    if(environment.RmaAddOn['FiltriProveAcquisto'] && environment.RmaAddOn['FiltriProveAcquisto'].find(x => x['source'] == 'ProdottiSource') != undefined)
      this.apiPaths.ClassicPost('/prodotti/list',{page: 0, size: 10, tipo: 68}).subscribe(data=>{
        this.DropdownSources.ProdottiSource = data?.data ?? [];
        // this.provaAcquisto.prodottoObject = this.DropdownSources.ProdottiSource.find(x=>x.id == this.provaAcquisto.prodottoId);
      })
    if(!this.Cliente  && localStorage.getItem('rmaCurrentUser')) {
      this.apiPaths.ClassicPost('/anagrafica/profilo/persona',{id: this.authSvc.currentUserValue.id}).subscribe(data=>{
        this.Cliente = JSON.parse(localStorage.getItem('rmaCurrentUser'));
        this.Cliente.indirizzo = data?.indirizzo;
        this.Cliente.citta = data?.citta;
        this.Cliente.provincia = data?.provincia;
        this.Cliente.cap = data?.cap;
        this.Cliente.telefono = data?.telefono;
        this.Cliente.email = data?.email;
        this.Cliente.nominativo = this.Cliente.nominativo ?? data?.fullName;
      })

    }
    if(this.Progetto)
      this.apiRestService.getProveAcquistoProgetto({id: this.Progetto?.id}).subscribe(data=>{
        this.List = this.filterList(data.data);
        this.collectionSize = data?.total
      })
    else if(this.permission.isOperativeRoles(['AC','C', 'AG'])) {
      this.apiPaths.ClassicPost('/rma/register/list', {matricola: "",},{ headers: this.rmaData.getRmaHeaders() },this.rmaData.getRmaLink()).subscribe(data=>{
        this.List =  this.filterList(data.data);
        this.collectionSize = data?.total
      })
    }
    else if(this.Cliente && this.Sede && !this.Local){
        this.apiRestService.getProveAcquistoSede({id: this.Sede}).subscribe(data=>{
          this.List =  this.filterList(data?.data) ?? [];
          this.collectionSize = data?.total
        });
    }
    else if(this.Cliente && !this.Local)
      this.apiRestService.getProveAcquistoCliente({id: this.Cliente?.id}).subscribe(data=>{
        this.List =  this.filterList(data.data);
        this.collectionSize = data?.total
        console.log('ProveAcquisto: ', this.List)
      })
    else if(this.Cliente && this.Local) {
      this.collectionSize = this.List?.length ?? 0;
      if(!init)
        this.onRefresh.emit();
    }
  }

  filterList(ProveAcquisto?: ProvaAcquisto[]) : ProvaAcquisto[]{
    var list = ProveAcquisto?.filter(x=> x.prodotto?.toLowerCase().includes(this.Filter?.prodotto?.toLowerCase()));
    if (this.environment.RmaAddOn['FiltriProveAcquisto'])
      list = this.campoUtility.getFilteredList(list,this.environment.RmaAddOn['FiltriProveAcquisto'], this.Filter)
    list.forEach(pa=>{
      pa['modelloObject'] = {prodotto: pa.prodotto};
    });
    return list;
  }

  add(item?: ProvaAcquisto) {
    if(environment.RmaAddOn.taskGenerico && !item){
      this.addRow();
    } else if( this.Progetto || (this.userValidityCheck(this.Cliente) || this.environment.RmaAddOn['bypassClientCheck']) || item?.id )
      {
        const editmodal = this.modalService.open(EditProvaAcquistoComponent,{
          centered: true,
          backdrop: 'static',
          size: 'xl',
        });
        (<EditProvaAcquistoComponent>editmodal.componentInstance).provaAcquisto = item ?? new ProvaAcquisto(this.permission.isOperativeRoles(["C", "AG"])? new Azienda() : (this.Cliente ?? new Azienda()));
        (<EditProvaAcquistoComponent>editmodal.componentInstance).Brand = item?.brandObject? [item?.brandObject]:[];
        (<EditProvaAcquistoComponent>editmodal.componentInstance).Acquisti = item?.acquistoObject? [item?.acquistoObject]:[];
        (<EditProvaAcquistoComponent>editmodal.componentInstance).Difetti = item?.difettoObject? [item?.difettoObject]:[];
        (<EditProvaAcquistoComponent>editmodal.componentInstance).cliente = !this.permission.isOperativeRoles(['C', 'AC', 'CA', 'AG'])? (this.Cliente ?? new Azienda()) : null;
        (<EditProvaAcquistoComponent>editmodal.componentInstance).Progetto = this.Progetto;
        (<EditProvaAcquistoComponent>editmodal.componentInstance).Sede = this.Sede;
        (<EditProvaAcquistoComponent>editmodal.componentInstance).onClose.subscribe(data => { this.refresh(); })
      }
      else
        this.toastService.warning("Inserisci tutti i campi dell'anagrafica richiesti e salva. (ragione sociale, indirizzo, citta, provincia, cap, telefono, email) ")
  }

  addRma(prova: ProvaAcquisto) {
    var dynamicRma = this.environment.TaskAddon['DynamicFields']?.find(x=>x?.type == 'R');

      var sede: any = this.Cliente?.sedi?.find(x=> parseInt(x.id.toString()) == parseInt(prova?.sedeObject?.id.toString())) ;
      var ritiro = Object.assign({}, sede ?? prova?.acquirente ?? this.Cliente);
      ritiro.nominativo = sede ? this.Cliente.nominativo : ritiro.nominativo;

      console.log("ProvaAcquisto: ", prova);
      console.log("Cliente: ", this.Cliente )
      console.log("Ritiro: ", ritiro)

      const newRma =  new Rma(prova?.id);
      newRma.acquirente = Object.assign({}, prova?.acquirente ?? this.Cliente);
      newRma.ritiro = Object.assign({}, ritiro);
      newRma.acquirente.referente = prova?.acquirente?.referenti?.length > 0? (prova?.acquirente?.referenti[0]?.cognome + " " + prova?.acquirente?.referenti[0]?.nome) : "";
      newRma.ritiro.referente = prova?.acquirente?.referenti?.length > 0? (prova?.acquirente?.referenti[0]?.cognome + " " + prova?.acquirente?.referenti[0]?.nome) : "";
      newRma.proveObject = prova ? [prova] : [];
      newRma.prove = prova ? [prova?.id] : [];
      newRma.sedeId = prova?.sedeObject?.id;
      newRma.sedeObject = prova?.sedeObject ? {id: prova?.sedeObject?.id, fullAddress: prova?.sedeObject?.label, clienteObject: Object.assign({}, this.Cliente)} : undefined;
      this.RmaStore.updateSelected(newRma);
    if(dynamicRma){
      newRma.cliente = this.Cliente;
      newRma.clienteId = this.Cliente?.id
      const editmodal = this.modalService.open(NewsComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<NewsComponent>editmodal.componentInstance).DynamicFields = dynamicRma;
      (<NewsComponent>editmodal.componentInstance).IsModal = true;
      (<NewsComponent>editmodal.componentInstance).Item = newRma;
      (<NewsComponent>editmodal.componentInstance).updated.subscribe(data => {
        this.refresh();
      });

    }else{
      const editmodal = this.modalService.open(RmaProdottoAddComponent, { centered: true, backdrop: 'static', size: 'xl',});
      (<RmaProdottoAddComponent>editmodal.componentInstance).onClose.subscribe (data => this.refresh() )
      console.log("Nuovo Rma: ", newRma)
    }



  }
  addVerifica(prova: ProvaAcquisto) {
    if(this.Progetto) {
      const newRma = new Rma(prova?.id);
      const nomeReferente = this.Progetto.clienteObject?.referenti[0]?.fullName ?? ((this.Progetto.clienteObject?.referenti[0]?.cognome ?? '') + " " + (this.Progetto?.clienteObject?.referenti[0]?.nome ?? ''));
      newRma.acquirente = Object.assign({}, this.Progetto.clienteObject ?? new Azienda());
      newRma.ritiro = Object.assign({}, this.Progetto.clienteObject ?? new Azienda());
      newRma.acquirente.referente = nomeReferente ?? undefined;
      newRma.ritiro.referente = nomeReferente ?? undefined;
      newRma.attivita = this.Progetto.attivita;
      this.RmaStore.updateSelected(newRma);
      const editmodal = this.modalService.open(RmaProdottoAddComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<RmaProdottoAddComponent>editmodal.componentInstance).onClose.subscribe(data => {
        this.refresh();
      })
    }
  }


  userValidityCheck(user){
    console.log(user)
    return  user?.nominativo && user.nominativo != "" &&
       user?.indirizzo && user.indirizzo != ""  &&
       user?.citta && user.citta != "" &&
       user?.cap && user.cap != "" &&
       user?.provincia && user.provincia != "" &&
       user?.telefono && user.telefono != "" &&
       user?.email && user.email != ""
  }

  addRow(){
    this.List.push({modifica:true})
  }

  salva(co: ProvaAcquisto) {
    this.send(this.FormGetter(co),this.apiPaths.getBaseAPI() + "/rma/register/add")
  }
  FormGetter(selected){
    var formData: FormData = new FormData();
    formData.append("prodotto", selected.prodotto);
    if(environment.RmaAddOn.Matricola)
      formData.append("seriale", selected.seriale)
    if(this.Cliente?.id)
      formData.append("cliente", this.Cliente?.id?.toString());
    if(this.Progetto?.id)
      formData.append("progetto", this.Progetto?.id?.toString());
    if(environment.RmaAddOn['Cliente']?.Referente)
      formData.append("acquirente[referente]", this.Cliente.referente)
    if(environment.RmaAddOn['Cliente']?.Nominativo)
      formData.append("acquirente[nominativo]", this.Cliente.nominativo)
    if(environment.RmaAddOn['Cliente']?.Indirizzo)
      formData.append("acquirente[indirizzo]", this.Cliente.indirizzo)
    if(environment.RmaAddOn['Cliente']?.Citta)
      formData.append("acquirente[citta]", this.Cliente.citta)
    if(environment.RmaAddOn['Cliente']?.Cap)
      formData.append("acquirente[cap]", this.Cliente.cap)
    if(environment.RmaAddOn['Cliente']?.Provincia)
      formData.append("acquirente[provincia]", this.Cliente.provincia)
    if(environment.RmaAddOn['Cliente']?.Telefono)
      formData.append("acquirente[telefono]", this.Cliente.telefono)
    if(environment.RmaAddOn['Cliente']?.Email)
      formData.append("acquirente[email]", this.Cliente.email)
    return formData;
  }
  send(formdata: FormData, link, headers = new HttpHeaders({Authorization: `Bearer ${this.authSvc?.currentUserValue?.access_token}`,})){
    this.http.request('POST', link, {
      body: formdata,
      reportProgress: true,
      observe: 'events',
      headers: headers,
      params: null,
    })
      .subscribe(
        (event) => {
          if (event.type === HttpEventType.UploadProgress) {
          } else if (event.type === HttpEventType.Response) {
            if (event.status === 200 || event.status === 201) {
              this.refresh()
            }
            else
              this.handleErrors(event);
          } else {
          }
        },
        (error) => {
          this.handleErrors(error);
        }
      );
  }
  handleErrors(err?) {
    if(err){
      let errorMessage = err.error.message || err.statusText;
      if (err.status === 422) {
        errorMessage = "";
        for (const field in err.error) {
          errorMessage += field + " : " + err.error[field] + '\n';
        }
      }
      this.toastService.error(errorMessage, "OOPS!!");
    }
  }

  delete(co: ProvaAcquisto) {
    if(confirm("Sei sicuro di voler eliminare questo elemento dalla lista?"))
      this.apiPaths.ClassicPost('/rma/register/delete',{id: co.id}, { headers: this.rmaData.getRmaHeaders() },this.rmaData.getRmaLink()).subscribe(()=> this.refresh());
      //this.apiRestService.deleteProvaAcquisto(co).subscribe(()=> this.refresh());
  }

  deleteLocal(co: ProvaAcquisto) {
    this.List?.splice(this.List?.findIndex(x=> x.id == co.id), 1);
  }


}
